import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "d-flex min-width-0" }
const _hoisted_2 = {
  key: 0,
  class: "m-0"
}
const _hoisted_3 = { class: "flex-fill text-truncate" }
const _hoisted_4 = { class: "text-truncate m-0" }
const _hoisted_5 = {
  key: 0,
  class: "text-truncate text-muted text-lowercase"
}
const _hoisted_6 = {
  key: 1,
  class: "text-center"
}

import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import ReactiveFilterableListOpenApiRequest from "~/core-ui/ts/request/ReactiveFilterableListOpenApiRequest";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {toggleArrayElement} from "~/ts/library/ToggleArrayElement";
import ReactiveRequestLoader from "~/cabinet/vue/interface/data/ReactiveRequestLoader.vue";
import ReactiveRequestPagination from "~/cabinet/vue/interface/pagination/ReactiveRequestPagination.vue";
import ElCardSection from "~/cabinet/vue/interface/card/ElCardSection.vue";
import CoreUiChatHistory from "~/core-ui/vue/chat/CoreUiChatHistory.vue";
import OperatorApplicationBuddyList from "~/operatorApplication/ts/service/OperatorApplicationBuddyList";
import {OperatorApplicationRoutingStore} from "~/operatorApplication/ts/store/OperatorApplicationRoutingStore";
import {__} from "~/ts/library/Translate";
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import {computed, ref} from "vue";
import ElConfirm from "~/core-ui/vue/ui/ElConfirm";
import ElPrompt from "~/core-ui/vue/ui/ElPrompt";
import {MessageBoxInputData} from "element-plus";
import OperatorApplicationSearchDialogForm
    from "~/operatorApplication/vue/dialogs/OperatorApplicationSearchDialogForm.vue";
import {IFiltersData} from "~/cabinet/vue/interface/filter/Interfaces";
import OperatorApplicationSearchDialogFormInterface
    from "~/operatorApplication/vue/dialogs/OperatorApplicationSearchDialogFormInterface";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import OperatorApplicationPlatformIcon from "~/operatorApplication/vue/misc/OperatorApplicationPlatformIcon.vue";
import {MESSAGE_COLOR_OPERATOR_DARK} from "~/operatorApplication/vue/dialogs/dialog/Constants";



const __default__ = {
    name: "OperatorApplicationSearchDialog"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    buddyList: {}
  }, {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["reload-custom-list"], ["update:visible"]),
  setup(__props: any, { emit: __emit }) {

let props = __props;

const TAB_FILTERS = "filters";
const TAB_RECIPIENT_ID = "recipientId";


let isCustomList = computed(() => {
    return !props.buddyList.isSystem;
});


let tabId = ref<string>(TAB_FILTERS);

let emits = __emit;

let isVisible = _useModel<boolean>(__props, "visible");

function close() {
    isVisible.value = false;
}

let model = ref<OperatorApplicationSearchDialogFormInterface>();


let showOperatorLogins = computed(() => {
    return OperatorAccountStore.data.value.accessRights.canViewOperatorsLogin;
});

let customOperatorStatusDictionary = OperatorAccountStore.customStatusDictionary;
let messageSourceTypeDictionary = OperatorAccountStore.messageSourceTypeDictionary;


let applicationPlatform = computed(() => {
    return OperatorApplicationPlatform;
});

let sites = computed(() => {
    let result = OperatorAccountStore.data.value.sites;
    if (model.value) {
        for (let siteId of model.value.siteIds) {
            if (!OperatorAccountStore.sitesDictionary.value[siteId]) {
                toggleArrayElement(model.value.siteIds, siteId, false);
            }
        }
    }
    return result;
});

async function getFiltersData(siteId?: string): Promise<IFiltersData> {
    let result = OperatorAccountStore.data.value.searchFilters;
    let siteIds = siteId ? [siteId] : [];
    if (siteIds.length == 1) {
        let site = OperatorAccountStore.sitesDictionary.value[siteIds[0]];
        if (site) {
            result = site.searchFilters;
        }
    }
    if (result.length < 10) {
        let p: OperatorApplicationApi.GetCustomBuddyListFiltersOpenApiModel = {};
        if (siteIds.length == 1) {
            p.siteId = siteIds[0];
        }
        let fetchResult = await (new OperatorApiRequest({
            url: "/buddyList/getCustomBuddyListFilters",
            p,
            silent: true
        })).send();
        if (fetchResult.isSuccess) {
            let data: OperatorApplicationApi.GetCustomBuddyListFiltersResultOpenApiModel = fetchResult.data as any;
            if (data.filtersData) {
                result = data.filtersData;
                if (siteIds.length == 1) {
                    let site = OperatorAccountStore.sitesDictionary.value[siteIds[0]];
                    if (site) {
                        site.searchFilters = result;
                    }
                } else {
                    OperatorAccountStore.data.value.searchFilters = result;
                }
            }
        }

        result = null;
    } else {
        result = JSON.parse(result);
    }
    return result as any;
}


let request = computed(() => {
    if (tabId.value == TAB_FILTERS) {
        let p: Partial<OperatorApplicationApi.OperatorBuddyListSearchOpenApiModel> = {};
        if (model.value) {
            p.siteIds = model.value.siteIds ? model.value.siteIds : [];
            if (model.value.query) {
                p.query = model.value.query;
            }
            if (model.value.filters) {
                p.filters = JSON.stringify(model.value.filters);
            }
        }
        return new ReactiveFilterableListOpenApiRequest(new OperatorApiRequest({
            url: "/buddyList/search",
            p
        }));
    } else {
        let p: Partial<OperatorApplicationApi.OperatorBuddyListSearchByRecipientIdOpenApiModel> = {};
        if (model.value) {
            p.siteIds = model.value.siteIds ? model.value.siteIds : [];
            if (model.value.query) {
                p.query = model.value.query;
            }
        }
        return new ReactiveFilterableListOpenApiRequest(new OperatorApiRequest({
            url: "/buddyList/searchByRecipientId",
            p
        }));
    }
});

let requestData = computed(() => {
    return request.value.data.items;
});

let operators = computed(() => {
    return OperatorAccountStore.data.value.operators;
});

let virtualOperators = computed(() => {
    let result = [];
    for (let site of sites.value) {
        result.push(...site.virtualOperators);
    }
    return result;
});

function clickOnCard(client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel, message?: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel) {
    isVisible.value = false;
    OperatorApplicationBuddyList.addClientAndOpenByUserdata(client, message?.id);
}

function getIntegrationPlatform(client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel): OperatorApplicationApi.OperatorGetParamsPlatformOpenApiModel {
    if (client.integration) {
        return OperatorAccountStore.integrationPlatformDictionary.value[client.integration.platformId];
    }
    return null;
}

let sitesDictionary = OperatorAccountStore.sitesDictionary;

async function getDescr() {
    if (model.value.descr) {
        return model.value.descr;
    }
    let promptResult: MessageBoxInputData = await ElPrompt("Введите название для списка на основе текущего поиска", "Создание нового списка") as any;
    if (promptResult.action == "confirm") {
        return promptResult.value;
    }
    return null;
}

async function saveSearch() {
    try {
        let descr = await getDescr();
        if (descr) {
            let p: OperatorApplicationApi.OperatorBuddyListSaveSearchOpenApiModel = {
                descr,
                siteIds: model.value.siteIds,
            };
            if (isCustomList.value) {
                p.id = props.buddyList.id;
            }
            if (model.value.query) {
                p.query = model.value.query;
            }
            if (model.value.filters) {
                p.filters = JSON.stringify(model.value.filters);
            }
            let result = await (new OperatorApiRequest({
                url: "/buddyList/saveSearch",
                p
            })).save();
            if (result.isSuccess) {
                if (isCustomList.value) {
                    emits("reload-custom-list");
                }
                close();
            }
        }
    } catch (e) {
        console.error(e);
    }
}

async function deleteSearch() {
    try {
        await ElConfirm(__("Вы уверены, что хотите удалить этот пункт меню?"));
        let p: OperatorApplicationApi.OperatorBuddyListDeleteSearchOpenApiModel = {
            id: props.buddyList.id
        }
        let result = await (new OperatorApiRequest({
            url: "/buddyList/deleteSearch",
            p
        })).save();
        if (result.isSuccess) {
            close();
            OperatorApplicationRoutingStore.openMainDialogs();
        }
    } catch (e) {

    }
}


const TABS: {
    id: string,
    descr: string,
    getFiltersMethod?: (siteId?: string) => Promise<IFiltersData>
}[] = isCustomList.value ? [{
    id: TAB_FILTERS,
    descr: __('Настройка динамического списка'),
    getFiltersMethod: getFiltersData
}] : [
    {
        id: TAB_FILTERS,
        descr: __("Поиск по фильтрам"),
        getFiltersMethod: getFiltersData
    },
    {
        id: TAB_RECIPIENT_ID,
        descr: __("Поиск по телефону или Email"),
        getFiltersMethod: null
    }
];


let selectedTab = computed(() => TABS.find(tab => tab.id == tabId.value));

let operatorMessageBackground = computed(() => {
    return OperatorApplicationConfigInstance.darkThemeEnabled ? MESSAGE_COLOR_OPERATOR_DARK : OperatorApplicationConfigInstance.operatorMessageBackground;
});

let clientMessageBackground = computed(() => {
    return OperatorApplicationConfigInstance.darkThemeEnabled ? 'client-dark' : undefined;
});


return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(isVisible),
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(isVisible) ? (isVisible).value = $event : isVisible = $event)),
    width: "900px",
    class: _normalizeClass({'sticky-footer dialog-with-tabs-title body-background': true})
  }, _createSlots({
    header: _withCtx(() => [
      _createVNode(_component_el_tabs, {
        modelValue: _unref(tabId),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(tabId) ? (tabId).value = $event : tabId = $event)),
        class: "header-tabs"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TABS), (tab) => {
            return (_openBlock(), _createBlock(_component_el_tab_pane, {
              label: tab.descr,
              name: tab.id
            }, null, 8, ["label", "name"]))
          }), 256))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_tabs, {
        modelValue: _unref(tabId),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(tabId) ? (tabId).value = $event : tabId = $event)),
        class: "dialog-body-tabs"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TABS), (tab) => {
            return (_openBlock(), _createBlock(_component_el_tab_pane, {
              name: tab.id
            }, {
              default: _withCtx(() => [
                (_unref(tabId) == tab.id)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_card, null, {
                        default: _withCtx(() => [
                          _createVNode(OperatorApplicationSearchDialogForm, {
                            "buddy-list": __props.buddyList,
                            sites: _unref(sites),
                            "get-filters": tab.getFiltersMethod,
                            "is-visible": _unref(isVisible),
                            modelValue: _unref(model),
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(model) ? (model).value = $event : model = $event))
                          }, {
                            buttons: _withCtx(() => [
                              (!_unref(isCustomList))
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 0,
                                    type: "primary",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(request).make(0, 9)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(__)("Найти")), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_unref(tabId) == TAB_FILTERS)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createVNode(_component_el_button, {
                                      class: _normalizeClass({ 'float-right': !_unref(isCustomList) }),
                                      type: _unref(isCustomList) ? 'primary' : null,
                                      onClick: saveSearch
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(isCustomList) ? _unref(__)("Сохранить") : _unref(__)("Сохранить поиск")), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["class", "type"]),
                                    (_unref(isCustomList))
                                      ? (_openBlock(), _createBlock(_component_el_button, {
                                          key: 0,
                                          type: "danger",
                                          class: "float-right",
                                          plain: "",
                                          onClick: deleteSearch
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(__)("Удалить")), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["buddy-list", "sites", "get-filters", "is-visible", "modelValue"])
                        ]),
                        _: 2
                      }, 1024),
                      (!_unref(isCustomList))
                        ? (_openBlock(), _createBlock(ReactiveRequestLoader, {
                            key: 0,
                            request: _unref(request),
                            class: _normalizeClass({'mt-4': _unref(request).data || _unref(request).isLoading})
                          }, {
                            default: _withCtx(() => [
                              (_unref(request).data)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_unref(requestData).length)
                                      ? (_openBlock(), _createBlock(_component_el_row, {
                                          key: 0,
                                          class: "d-flex flex-wrap",
                                          gutter: 20
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(requestData), (item) => {
                                              return (_openBlock(), _createBlock(_component_el_col, {
                                                key: item.client.id,
                                                class: "flex-fill mb-3",
                                                span: 8
                                              }, {
                                                default: _withCtx(() => [
                                                  _withDirectives((_openBlock(), _createBlock(_component_el_card, { class: "cursor-pointer h-100" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(ElCardSection, null, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_1, [
                                                            (getIntegrationPlatform(item.client))
                                                              ? (_openBlock(), _createElementBlock("h5", _hoisted_2, [
                                                                  _createVNode(OperatorApplicationPlatformIcon, {
                                                                    platform: getIntegrationPlatform(item.client),
                                                                    class: "mr-1"
                                                                  }, null, 8, ["platform"])
                                                                ]))
                                                              : _createCommentVNode("", true),
                                                            _createElementVNode("div", _hoisted_3, [
                                                              _createElementVNode("h5", _hoisted_4, _toDisplayString(item.client.displayDescr), 1),
                                                              (_unref(sitesDictionary)[item.client.siteId])
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(sitesDictionary)[item.client.siteId].title), 1))
                                                                : _createCommentVNode("", true)
                                                            ])
                                                          ])
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      (item.messages.length)
                                                        ? (_openBlock(), _createBlock(ElCardSection, { key: 0 }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(CoreUiChatHistory, {
                                                                "short-message-margin": "",
                                                                client: item.client,
                                                                operators: _unref(operators),
                                                                "virtual-operators": _unref(virtualOperators),
                                                                "client-message-background": _unref(clientMessageBackground),
                                                                "operator-message-background": _unref(operatorMessageBackground),
                                                                messages: item.messages,
                                                                "operator-application-platform": _unref(applicationPlatform),
                                                                "show-operator-logins": _unref(showOperatorLogins),
                                                                "custom-operator-status-dictionary": _unref(customOperatorStatusDictionary),
                                                                "message-source-type-dictionary": _unref(messageSourceTypeDictionary)
                                                              }, null, 8, ["client", "operators", "virtual-operators", "client-message-background", "operator-message-background", "messages", "operator-application-platform", "show-operator-logins", "custom-operator-status-dictionary", "message-source-type-dictionary"])
                                                            ]),
                                                            _: 2
                                                          }, 1024))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                  }, 1024)), [
                                                    [_directive_on_native, () => clickOnCard(item.client, item.messages[0]), "click"]
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createElementBlock("h4", _hoisted_6, _toDisplayString(_unref(__)("Чаты по заданным критериям не найдены")), 1))
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["request", "class"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["name"]))
          }), 256))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 2
  }, [
    (_unref(request).data)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createVNode(ReactiveRequestPagination, { "list-request": _unref(request) }, null, 8, ["list-request"])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue"]))
}
}

})